import moment from "moment";
import { EventStatusType, MetadataType, GooglePlacesResult, AssetType, UserAsset, UserAssetType, InventoryItemAssetType, UserEmployment, UserAssistance, Department, EmploymentLogType, EmploymentScheduleType, IssuesStatus, IssueType } from "./SiteClasses";
import { Location } from "./SiteClasses";
import { IconName } from "react-frontier";

const bindClose = <T>(setVal: (val: T)=>void, val?: T)=>{
	return ()=>{
		setVal((val as any) || null);
	}
}

const bindChange = (setVal: (val: any, ...args: any)=>void)=>{
	return (e: { target: { value: string } } | any)=>{
		return setVal(e.target.value);
	}
}

const bindToggle = (val: any, setVal: any)=>{
	return ()=>{
		setVal(!val);
	}
}

const bindFormChange = <T>(val: T, setVal: (val: any, ...args: any)=>void, setDirty?: (val: boolean)=>void)=>{
	return (name: keyof T, semantic: boolean=false, target: boolean=false)=>{
		return (e: { target: { value: string } } | any, data?: { value?: any, checked: boolean } | any)=>{
			if(semantic){
				setVal({ ...val, [name]: typeof data.checked!=='undefined' ? data.checked : data.value });
			}else if(target){
				setVal({ ...val, [name]: e.target.value })
			}else{
				setVal({ ...val, [name]: e });
			}
			if(setDirty) setDirty(true);
		}
	}
}

function addCommas(num: number, fixed: boolean=true, hideZero: boolean=false){
	if (!num && num !== 0) return null;
	if(typeof num==='string'){
		num = parseFloat(num as string);
	}
	var c = num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	var dec = c.substring(c.length-2, c.length);
	return fixed ? (hideZero && dec === '00' ? c.slice(0, -3) : c) : c.slice(0, -3);
}

function dashify(what: any, num: number=4, delimiter: string='-'){
	what = what.toString();
	var ret = '';
	for(var i=0; i<what.length; i++){
		if(i%num===0 && i!==0)ret+=delimiter;
		ret += what[i];
	}
	return ret;
}

function unix(){
	return Math.floor(new Date().getTime()/1000);
}

function uniqueArray<T>(array: T[]){
	return Array.from<T>(new Set(array));
}

function validatePassword(val: string){
	return (/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*\-\.\,\+\*])[a-zA-Z0-9!@#$%^&*\-\.\,\+\*]{8,32}$/).test(val);
}

function partition<T>(a: T[], n: number) : T[][]{
	var array = [...a];
	return array.length ? [array.splice(0, n)].concat(partition(array, n)) : [];
}

function cropString(str: string, len: number, elip: boolean=false){
	if(!str) return '';
	var elip = elip && str.length>len;
	return str.trim().substring(0, len-(elip ? 3 : 0)).trim() + (elip ? '...' : '');
}

function randomRange(min: number, max: number){
	return Math.floor(Math.random() * (max-min+1)+min);
}

function isJWT(token: string){
	return (/(^[A-Za-z0-9-_]*\.[A-Za-z0-9-_]*\.[A-Za-z0-9-_]*$)/gi).test(token);
}

function priorityText(p: number){
	switch(p) {
		case 1: return 'Baja';
		case 2: return 'Media';
		case 3: return 'Alta';
		case 4: return 'Crítica';
		default: return 'Desconocida';
	}
}

function priorityColor(p: number){
	switch(p) {
		case 1: return 'yellow';
		case 2: return 'blue';
		case 3: return 'orange';
		case 4: return 'red';
		default: return 'black';
	}
}

function statusColor(s: number){
	switch(s) {
		case IssuesStatus.PENDING: return 'yellow';
		case IssuesStatus.IN_PROGRESS: return 'blue';
		case IssuesStatus.ON_HOLD: return 'orange';
		case IssuesStatus.RESOLVED: return 'green';
		case IssuesStatus.CANCELLED: return 'red';
		default: return 'black';
	}
}

function randomCode(length: number, tolerance: number=0, lowercase: boolean=false, specials: boolean=false){
	var codeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
	if(lowercase) codeChars += 'abcdefghijklmnopqrstuvwxyz';
	if(specials) codeChars += '@$!%*#?&.,*+';
	if(tolerance) length += randomRange(-tolerance, tolerance);

	var code = "";
	for (var i = 0; i < length; i++) code += codeChars[Math.floor(Math.random() * codeChars.length)];
	return code;
}

function timeConverter(date: number){
	return moment.unix(date).format('DD/MMM/YY')
}

function formatCreditCard(val: string){
	val = val.replace(/\ /g, '');
	var final_val = '';
	for(var i=0; i<val.length; i++){
		final_val += val[i];
		if(((i+1)%4)===0 && i<(val.length-1)){
			final_val += ' '
		}
	}
	return final_val;
}

function getBankParticipants(){
	return [
		{ participant: 40133, bank_name: "ACTINVER" },
		{ participant: 40062, bank_name: "AFIRME" },
		{ participant: 90721, bank_name: "albo" },
		{ participant: 0, bank_name: "AMERICAN EXPRESS" },
		{ participant: 90706, bank_name: "ARCUS FI" },
		{ participant: 90659, bank_name: "ASP INTEGRA OPC" },
		{ participant: 40127, bank_name: "AZTECA" },
		{ participant: 37166, bank_name: "BaBien" },
		{ participant: 40030, bank_name: "BAJIO" },
		{ participant: 40002, bank_name: "BANAMEX" },
		{ participant: 40154, bank_name: "BANCO COVALTO" },
		{ participant: 37006, bank_name: "BANCOMEXT" },
		{ participant: 40137, bank_name: "BANCOPPEL" },
		{ participant: 40160, bank_name: "BANCO S3" },
		{ participant: 40152, bank_name: "BANCREA" },
		{ participant: 37019, bank_name: "BANJERCITO" },
		{ participant: 40147, bank_name: "BANKAOOL" },
		{ participant: 40106, bank_name: "BANK OF AMERICA" },
		{ participant: 40159, bank_name: "BANK OF CHINA" },
		{ participant: 37009, bank_name: "BANOBRAS" },
		{ participant: 40072, bank_name: "BANORTE" },
		{ participant: 40058, bank_name: "BANREGIO" },
		{ participant: 40060, bank_name: "BANSI" },
		{ participant: 2001, bank_name: "BANXICO" },
		{ participant: 40129, bank_name: "BARCLAYS" },
		{ participant: 40145, bank_name: "BBASE" },
		{ participant: 40012, bank_name: "BBVA MEXICO" },
		{ participant: 40112, bank_name: "BMONEX" },
		{ participant: 90677, bank_name: "CAJA POP MEXICA" },
		{ participant: 90683, bank_name: "CAJA TELEFONIST" },
		{ participant: 90715, bank_name: "CASHI CUENTA" },
		{ participant: 90631, bank_name: "CI BOLSA" },
		{ participant: 40124, bank_name: "CITI MEXICO" },
		{ participant: 90901, bank_name: "CLS" },
		{ participant: 90903, bank_name: "CoDi Valida" },
		{ participant: 40130, bank_name: "COMPARTAMOS" },
		{ participant: 40140, bank_name: "CONSUBANCO" },
		{ participant: 90725, bank_name: "COOPDESARROLLO" },
		{ participant: 90652, bank_name: "CREDICAPITAL" },
		{ participant: 90688, bank_name: "CREDICLUB" },
		{ participant: 90680, bank_name: "CRISTOBAL COLON" },
		{ participant: 90723, bank_name: "Cuenca" },
		{ participant: 90729, bank_name: "Dep y Pag Dig" },
		{ participant: 40151, bank_name: "DONDE" },
		{ participant: 90616, bank_name: "FINAMEX" },
		{ participant: 90634, bank_name: "FINCOMUN" },
		{ participant: 90734, bank_name: "FINCO PAY" },
		{ participant: 90738, bank_name: "FINTOC" },
		{ participant: 90699, bank_name: "FONDEADORA" },
		{ participant: 90685, bank_name: "FONDO (FIRA)" },
		{ participant: 90601, bank_name: "GBM" },
		{ participant: 40167, bank_name: "HEY BANCO" },
		{ participant: 37168, bank_name: "HIPOTECARIA FED" },
		{ participant: 40021, bank_name: "HSBC" },
		{ participant: 40155, bank_name: "ICBC" },
		{ participant: 40036, bank_name: "INBURSA" },
		{ participant: 90902, bank_name: "INDEVAL" },
		{ participant: 40150, bank_name: "INMOBILIARIO" },
		{ participant: 40136, bank_name: "INTERCAM BANCO" },
		{ participant: 40059, bank_name: "INVEX" },
		{ participant: 40110, bank_name: "JP MORGAN" },
		{ participant: 40128, bank_name: "KAPITAL" },
		{ participant: 90661, bank_name: "KLAR" },
		{ participant: 90653, bank_name: "KUSPIT" },
		{ participant: 90670, bank_name: "LIBERTAD" },
		{ participant: 90602, bank_name: "MASARI" },
		{ participant: 90722, bank_name: "Mercado Pago W" },
		{ participant: 90720, bank_name: "MexPago" },
		{ participant: 40042, bank_name: "MIFEL" },
		{ participant: 40158, bank_name: "MIZUHO BANK" },
		{ participant: 90600, bank_name: "MONEXCB" },
		{ participant: 40108, bank_name: "MUFG" },
		{ participant: 40132, bank_name: "MULTIVA BANCO" },
		{ participant: 37135, bank_name: "NAFIN" },
		{ participant: 40638, bank_name: "NU MEXICO" },
		{ participant: 90710, bank_name: "NVIO" },
		{ participant: 40148, bank_name: "PAGATODO" },
		{ participant: 90732, bank_name: "Peibo" },
		{ participant: 90714, bank_name: "PPBALANCEMX" },
		{ participant: 90620, bank_name: "PROFUTURO" },
		{ participant: 40156, bank_name: "SABADELL" },
		{ participant: 40014, bank_name: "SANTANDER" },
		{ participant: 40044, bank_name: "SCOTIABANK" },
		{ participant: 40157, bank_name: "SHINHAN" },
		{ participant: 90728, bank_name: "SPIN BY OXXO" },
		{ participant: 90646, bank_name: "STP" },
		{ participant: 90730, bank_name: "Swap" },
		{ participant: 90703, bank_name: "TESORED" },
		{ participant: 90684, bank_name: "TRANSFER" },
		{ participant: 90727, bank_name: "TRANSFER DIRECT" },
		{ participant: 40138, bank_name: "UALA" },
		{ participant: 90656, bank_name: "UNAGRA" },
		{ participant: 90617, bank_name: "VALMEX" },
		{ participant: 90605, bank_name: "VALUE" },
		{ participant: 40113, bank_name: "VE POR MAS" },
		{ participant: 40141, bank_name: "VOLKSWAGEN" },
	]
}

function validateClabeParticipant(clabe: string){
	return ['001', '002', '006', '009',
	'012', '014', '019', '021',
	'030', '036', '042', '044',
	'058', '059', '060', '062',
	'072', '106', '108', '110',
	'112', '113', '126', '127',
	'128', '129', '130', '132',
	'133', '135', '136', '137',
	'138', '140', '141', '143',
	'145', '147', '148', '150',
	'151', '152', '154', '155',
	'156', '157', '158', '159',
	'160', '166', '168', '600',
	'601', '602', '605', '608',
	'613', '616', '617', '620',
	'630', '631', '634', '638',
	'646', '648', '652', '653',
	'656', '659', '670', '677',
	'680', '683', '684', '685',
	'686', '688', '689', '703',
	'706', '710', '722', '723',
	'728', '901', '902', '903',
	'661', '721', '699', '732'].indexOf(clabe.toString().substring(0, 3))!==-1;
}

const bindClick = <T>(setVal: (val: (T | null))=>void, val: (T | null)=null)=>{
	return ()=>{
		setVal(val);
	}
}

function getEventStatusLabel(status: EventStatusType): { label: string; color: any } {
	var map : {
		[x in EventStatusType]: { label: string; color: string }
	} = {
		[EventStatusType.OPERATING]: { label: 'Operado por AREMA', color: "blue" },
		[EventStatusType.PROMOTER_OPERATED]: { label: 'Operado por el promotor', color: "yellow" },
		[EventStatusType.POSTPONED]: { label: 'Pospuesto', color: "orange" },
		[EventStatusType.CANCELLED]: { label: 'Cancelado', color: "red" },
		[EventStatusType.NOT_OPERATED]: { label: 'No operado', color: "gray" }
	};

	return map[status];
}

function getMetadataTypeName(type_id: MetadataType){
	var names : {
		[x in MetadataType]: string
	} = {
		[MetadataType.INPUT]: 'Texto',
		[MetadataType.TEXTAREA]: 'Texto largo',
		[MetadataType.DROPDOWN]: 'Opciones',
		[MetadataType.MULTIPLE]: 'Opcion múltiple',
		[MetadataType.CHECKBOX]: 'Si / No',
	}
	return names[type_id];
}

function joinUrls(parent: string, path: string){
	if(parent.endsWith('/')){
		parent = parent.substring(0, parent.length-1);
	}
	if(!path.startsWith('/')){
		path = '/'+path;
	}
	return `${parent}${path}`;
}

function capitalizeName(name: string){
	if(!name || name.length===0) return '';
	var words = name.split(' ');
	var prepositions = ['de', 'la'];
	var new_words = [];
	for(var i of words){
		var w = i.trim();
		if(prepositions.indexOf(w.toLowerCase())!==-1){
			new_words.push(w);
		}else{
			new_words.push(`${w.substring(0, 1).toUpperCase()}${w.substring(1).toLowerCase()}`)
		}
	}
	return new_words.join(' ');
}

function formatPlacesComponents(result: GooglePlacesResult){
	var place : any = {
		name: result.name,
		place_id: result.place_id,
		phone: null,
		street: null,
		exterior_number: null,
		interior_number: null,
		neighborhood: null,
		city: null,
		state: null,
		zipcode: null,
		country: null,
		lattitude: null,
		longitude: null,
	}
	var place_identifiers: any = {
		street: {
			type: ['street_address', 'route'],
		},
		exterior_number: {
			type: 'street_number'
		},
		interior_number: {
			type: ['room', 'subpremise']
		},
		neighborhood: {
			type: ['neighborhood', 'sublocality']
		},
		city: {
			type: 'locality'
		},
		zipcode: {
			type: 'postal_code'
		},
		state: {
			long_name: true,
			type: 'administrative_area_level_1'
		},
		country: {
			type: 'country'
		}
	}

	place.longitude = result && result.geometry && result.geometry.location && typeof result.geometry.location.lng === 'function' ? result.geometry.location.lng() : null;
	place.lattitude = result && result.geometry && result.geometry.location && typeof result.geometry.location.lat === 'function' ? result.geometry.location.lat() : null;

	for(var i of (result && result.address_components) || []){
		for(var k of Object.keys(place_identifiers)){
			var types = place_identifiers[k].type;
			if(!Array.isArray(types)) types = [types];
			for(var t of types){
				if(i.types.indexOf(t)!==-1){
					if(k==='address_2' && place['street']===i.long_name) continue;
					place[k] = place_identifiers[k].long_name===false ? i.short_name : i.long_name
					break;
				}
			}
		}
	}
	return place as Location;
}

function formatPlacesTemp(result?: Location | null){
    const base_place: Location = {
        name: null,
        place_id: null,
        phone: null,
        street: null,
        exterior_number: null,
        interior_number: null,
        neighborhood: null,
        city: null,
        state: null,
        zipcode: null,
        country: null,
        lattitude: null,
        longitude: null,
    };

    if(!result) return base_place;
    return { ...base_place, ...(result as Location) };
}

function formatAddress(location: Location){
	return [
		location.name,
		location.city,
	].filter(a=>!!a).join(', ');
}

function formatFullAddress(location?: Location | null){
   if(!location) return '';

   var streetLine = [location.street, location.exterior_number, location.interior_number]
      .filter(Boolean)
      .join(' ');

   return [
      location.name,
      streetLine || location.street,
      location.neighborhood,
      location.city,
      location.state,
      location.zipcode,
   ].filter(a=>!!a).join(', ');
}

function formatFullAddressMX(location?: Location | null): string {
   if(!location) return '';

   const clean = (v?: string | number | null) =>
   v === null || v === undefined ? '' : String(v).trim();

   const street = clean(location.street);
   const ext = clean(location.exterior_number);
   const int = clean(location.interior_number);

   const streetLine = [
      street,
      ext,
      int && `Int. ${int}`,
   ].filter(Boolean).join(' ').trim();

   const neighborhood = clean(location.neighborhood);
   const city = clean(location.city);
   const zipcode = clean(location.zipcode);

   const state = clean(location.state);

   const stateAbbr = clean((location as any).state_abbr) || (state.length > 0 ? state.slice(0, 3) + '.' : '');

   const parts: string[] = [
      streetLine,
      neighborhood,
      city,
   ].filter(Boolean);

   const zipAndState = [zipcode, state.toUpperCase()]
      .filter(Boolean)
      .join(' ')
      .trim();

   if(zipAndState) parts.push(zipAndState);
   if(stateAbbr) parts.push(stateAbbr);

  return parts.join(', ');
}


function relativeTime(end: number, start?: number){
	if(!start) start = Math.floor(new Date().getTime()/1000);

	var isPast = end < start;
	var diff_seconds = Math.abs(end - start);
	var diff_days = Math.floor(diff_seconds / 86400);

	var diff : string[] = [];

	if(diff_days >= 30){
		var months = Math.floor(diff_days / 30);
		var remaining_days = diff_days % 30;

		diff.push(`${months} mes${months===1 ? '' : 'es'}`);
		if(remaining_days > 0){
			diff.push(`${remaining_days} día${remaining_days===1 ? '' : 's'}`);
		}
	}else{
		diff.push(`${diff_days} día${diff_days===1 ? '' : 's'}`);
	}

	return `${isPast ? 'hace' : 'en'} ${diff.join(', ')}`
}

function getAssetTypeName(type_id: AssetType){
	switch(type_id){
		case AssetType.IMAGE: return 'Imagen';
		case AssetType.PDF: return 'PDF';
		case AssetType.VIDEO: return 'Video';
		default: return '???';
	}
}

function getAssetTypeIcon(type_id: AssetType) : IconName{
	switch(type_id){
		case AssetType.IMAGE: return 'file-image';
		case AssetType.PDF: return 'file-pdf';
		case AssetType.VIDEO: return 'file-video';
		default: return 'file';
	}
}

function getUserAssetTypeName(type_id: UserAssetType){
	switch(type_id){
		case UserAssetType.ID: return 'Identificación';
		case UserAssetType.ADDRESS: return 'Domicilio';
		case UserAssetType.CIF: return 'CIF';
		case UserAssetType.CURP: return 'CURP';
	}
}

function getInventoryItemAssetTypeName(type_id: InventoryItemAssetType){
	switch(type_id){
		case InventoryItemAssetType.INVOICE: return 'Factura de compra';
		default: return '??';
	}
}

function getEmploymentLogTypeName(type_id: EmploymentLogType | number){
	switch(type_id){
		case EmploymentLogType.VACATIONS: return 'Vacaciones';
		case EmploymentLogType.PERMISSION: return 'Permiso';
		case EmploymentLogType.AUTHORIZED_REST: return 'Descanso autorizado';
		case EmploymentLogType.DISABILITY: return 'Incapacidad';
		case EmploymentLogType.ADJUSTMENT: return 'Ajuste';
		default: return 'Incidencia';
	}
}

function getEmploymentLogTypeOptions(){
	return [
		{ key: EmploymentLogType.VACATIONS, value: EmploymentLogType.VACATIONS, text: getEmploymentLogTypeName(EmploymentLogType.VACATIONS) },
		{ key: EmploymentLogType.PERMISSION, value: EmploymentLogType.PERMISSION, text: getEmploymentLogTypeName(EmploymentLogType.PERMISSION) },
		{ key: EmploymentLogType.AUTHORIZED_REST, value: EmploymentLogType.AUTHORIZED_REST, text: getEmploymentLogTypeName(EmploymentLogType.AUTHORIZED_REST) },
		{ key: EmploymentLogType.DISABILITY, value: EmploymentLogType.DISABILITY, text: getEmploymentLogTypeName(EmploymentLogType.DISABILITY) },
	];
}

function getEmploymentScheduleTypeName(type_id: EmploymentScheduleType | number){
	switch(type_id){
		case EmploymentScheduleType.REST: return 'Descanso';
		case EmploymentScheduleType.WORK:
		default: return 'Laboral';
	}
}

function getEmploymentScheduleTypeOptions(){
	return [
		{ key: EmploymentScheduleType.WORK, value: EmploymentScheduleType.WORK, text: getEmploymentScheduleTypeName(EmploymentScheduleType.WORK) },
		{ key: EmploymentScheduleType.REST, value: EmploymentScheduleType.REST, text: getEmploymentScheduleTypeName(EmploymentScheduleType.REST) },
	];
}

function formatTimeRange(startHour: number, endHour: number){
	const formatHour = (hour: number) =>
		`${String(Math.floor(hour)).padStart(2, '0')}:${String(Math.round((hour % 1) * 60)).padStart(2, '0')}`;
	return `${formatHour(startHour)} - ${formatHour(endHour)}`;
}

enum CheckInStatus{
	PEDNIG = 1,
	ACTIVE_ON_TIME = 2,
	ACTIVE_LATE = 3,
	ACTIVE_RETARDED = 4,
	FINISHED_ON_TIME = 5,
	FINISHED_EARLIER = 6,
	FINISHED_LATE = 7,
	FINISHED_ARRIVED_LATE = 8,
	FINISHED_ARRIVED_RETARDED = 9,
	VACATION = 20,
	PERMISSION = 21,
	AUTHORIZED_REST = 22,
	DISABILITY = 23,
	INCIDENCE = 24,
}

function getArrivalStatus(employee: UserEmployment | UserAssistance): 'on_time' | 'late' | 'penalty' {
	var checkInMoment = moment.unix(employee.date_start);
	var checkInTimeOfDay = checkInMoment.hours() * 60 + checkInMoment.minutes();
	var minutesDifference = checkInTimeOfDay - employee.time_start;
	var secondsDifference = minutesDifference * 60;

	if(secondsDifference > employee.penalty_seconds) return 'penalty';
	if(secondsDifference > employee.late_seconds) return 'late';
	return 'on_time';
}

function getCheckInStatus(employee: UserEmployment | UserAssistance): CheckInStatus{
	if(employee.log_type_id){
		switch(employee.log_type_id){
			case EmploymentLogType.VACATIONS: return CheckInStatus.VACATION;
			case EmploymentLogType.PERMISSION: return CheckInStatus.PERMISSION;
			case EmploymentLogType.AUTHORIZED_REST: return CheckInStatus.AUTHORIZED_REST;
			case EmploymentLogType.DISABILITY: return CheckInStatus.DISABILITY;
			default: return CheckInStatus.INCIDENCE;
		}
	}
	if(employee.type_id === EmploymentScheduleType.REST) return CheckInStatus.AUTHORIZED_REST;
	if(!employee.date_start) return CheckInStatus.PEDNIG;

	var arrival = getArrivalStatus(employee);

	if(employee.date_end){
		if(arrival === 'penalty') return CheckInStatus.FINISHED_ARRIVED_RETARDED;
		if(arrival === 'late') return CheckInStatus.FINISHED_ARRIVED_LATE;

		var checkOutMoment = moment.unix(employee.date_end);
		var checkOutTimeOfDay = checkOutMoment.hours() * 60 + checkOutMoment.minutes();

		if(checkOutTimeOfDay < employee.time_end) return CheckInStatus.FINISHED_EARLIER;
		if(checkOutTimeOfDay > employee.time_end) return CheckInStatus.FINISHED_LATE;
		return CheckInStatus.FINISHED_ON_TIME;
	}

	if(arrival === 'penalty') return CheckInStatus.ACTIVE_RETARDED;
	if(arrival === 'late') return CheckInStatus.ACTIVE_LATE;
	return CheckInStatus.ACTIVE_ON_TIME;
}

function getStatusColor(status: number): 'blue' | 'green' | 'orange' | 'red' | 'yellow' {
	switch(status){
		case CheckInStatus.PEDNIG: return 'blue';
		case CheckInStatus.VACATION: return 'blue';
		case CheckInStatus.PERMISSION: return 'orange';
		case CheckInStatus.AUTHORIZED_REST: return 'yellow';
		case CheckInStatus.DISABILITY: return 'red';
		case CheckInStatus.INCIDENCE: return 'blue';
		case CheckInStatus.ACTIVE_ON_TIME: return 'green';
		case CheckInStatus.ACTIVE_LATE: return 'orange';
		case CheckInStatus.ACTIVE_RETARDED: return 'red';
		case CheckInStatus.FINISHED_ON_TIME: return 'green';
		case CheckInStatus.FINISHED_EARLIER: return 'red';
		case CheckInStatus.FINISHED_LATE: return 'orange';
		case CheckInStatus.FINISHED_ARRIVED_LATE: return 'orange';
		case CheckInStatus.FINISHED_ARRIVED_RETARDED: return 'red';
		default: return 'blue';
	}
}

function getStatusLabel(status: number): string | null {
	switch(status){
		case CheckInStatus.PEDNIG: return 'Pendiente';
		case CheckInStatus.VACATION: return 'Vacaciones';
		case CheckInStatus.PERMISSION: return 'Permiso';
		case CheckInStatus.AUTHORIZED_REST: return 'Descanso';
		case CheckInStatus.DISABILITY: return 'Incapacidad';
		case CheckInStatus.INCIDENCE: return 'Incidencia';
		case CheckInStatus.ACTIVE_ON_TIME:
		case CheckInStatus.ACTIVE_LATE:
		case CheckInStatus.ACTIVE_RETARDED: return 'Activo';
		case CheckInStatus.FINISHED_ON_TIME:
		case CheckInStatus.FINISHED_EARLIER:
		case CheckInStatus.FINISHED_LATE: return 'Finalizado';
		case CheckInStatus.FINISHED_ARRIVED_LATE: return 'Tarde';
		case CheckInStatus.FINISHED_ARRIVED_RETARDED: return 'Penalizado';
		default: return null;
	}
}

function getDepartmentName(id: Department){
	switch(id){
		case Department.OPERACIONES: return 'Operaciones';
		case Department.COMERCIAL: return 'Comercial';
		case Department.DESARROLLO: return 'Desarrollo';
		case Department.RECURSOS_HUMANOS: return 'RH';
		case Department.MARKETING: return 'Marketing';
		case Department.CONTABILIDAD: return 'Contabilidad';
		default: return null;
	}
}

function formatCreatorName(name: string){
	if (!name) return '';
	var parts = name.trim().split(' ');
	if (parts.length <= 2) return name;
	return `${parts[0]} ${parts[1]}`;
}

var getStatusName = (status: number | IssuesStatus, fallback?: string) => {
   switch(status) {
      case IssuesStatus.PENDING: return 'Abierto';
      case IssuesStatus.IN_PROGRESS: return 'En progreso';
      case IssuesStatus.ON_HOLD: return 'En espera';
      case IssuesStatus.RESOLVED: return 'Resuelto';
      case IssuesStatus.CANCELLED: return 'Cancelado';
      default: return fallback || '';
   }
};

var getScheduleInfo = (dateSchedule?: number, statusId?: number | IssuesStatus) => {
   if (!dateSchedule || isNaN(Number(dateSchedule))) return null;
   if (statusId === IssuesStatus.RESOLVED || statusId === IssuesStatus.CONFIRMED) return null;
   var ts = Number(dateSchedule);
   var target = ts > 1e11 ? moment(ts).startOf('day') : moment.unix(ts).startOf('day');
   if (!target.isValid()) return null;

   var today = moment().startOf('day');
   var diff = target.diff(today, 'days');

   if (diff < 0) {
      return {
         text: `Vencido (${Math.abs(diff)} ${Math.abs(diff) === 1 ? 'día' : 'días'})`,
         isUrgent: true,
         diff
      };
   }
   if (diff === 0) {
      return {
         text: 'Vence hoy',
         isUrgent: true,
         diff
      };
   }
   if (diff === 1) {
      return {
         text: 'Falta 1 día',
         isUrgent: true,
         diff
      };
   }
   return {
      text: `Faltan ${diff} días`,
      isUrgent: diff <= 3,
      diff
   };
};

const PRIORITY_TYPES: Omit<IssueType, 'type_icon'>[]=[
	{ type_id: 1, type_name: "Boletos Museo Cera"  },
	{ type_id: 2, type_name: "Rollo Museo Historia" },
	{ type_id: 3, type_name: "Rollo Museo Milarca" },
	{ type_id: 4, type_name: "Rollo PDV (Recibo)" },
	{ type_id: 5, type_name: "Boleto Circo Tihany" },
	{ type_id: 6, type_name: "Boleto Arematicket"},
	{ type_id: 7, type_name: "Etiquetas para Evento" },
	{ type_id: 8, type_name: "Taquilla Express" },
	{ type_id: 9, type_name: "Documentación" },
	{ type_id: 10, type_name: "Checadoras" },
	{ type_id: 15, type_name: "Equipos" }
]

function sortedToPriority(types: IssueType[]){
	if(!types) return [];

	let sortedTypes: IssueType[] = [];
	
	types.forEach((type)=>
		PRIORITY_TYPES.find(t=>t.type_name.toLowerCase().trim()===type.type_name.toLowerCase().trim()) 
		? sortedTypes.unshift(type) 
		: sortedTypes.push(type)
	);

	return sortedTypes;
}

export {
	addCommas,
	bindChange,
	bindClick,
	bindClose,
	bindFormChange,
	bindToggle,
	capitalizeName,
	cropString,
	dashify,
	formatAddress,
   formatFullAddress,
   formatFullAddressMX,
	formatCreditCard,
	formatCreatorName,
	formatPlacesComponents,
   formatPlacesTemp,
	formatTimeRange,
	getAssetTypeIcon,
	getAssetTypeName,
	getBankParticipants,
	getCheckInStatus,
	getEmploymentLogTypeName,
	getEmploymentLogTypeOptions,
	getEmploymentScheduleTypeName,
	getEmploymentScheduleTypeOptions,
	getDepartmentName,
	getEventStatusLabel,
	getMetadataTypeName,
	getStatusColor,
	getStatusLabel,
	getUserAssetTypeName,
	getInventoryItemAssetTypeName,
	isJWT,
	joinUrls,
	partition,
	randomCode,
	randomRange,
	relativeTime,
	timeConverter,
	uniqueArray,
	unix,
	validateClabeParticipant,
	validatePassword,
	priorityColor,
	statusColor,
	priorityText,
	getStatusName,
	getScheduleInfo,
	sortedToPriority
}
